import { toast } from 'react-hot-toast';

const toastStyles = {
  style: {
    background: '#23262c',
    color: '#f3f4f6',
    width: 'auto',
    maxWidth: 'clamp(320px, 60vw, 380px)',
    textAlign: 'center' as const,
    wordBreak: 'break-word' as const,
  },
};

const toastClient = {
  success: (message: string) => toast.success(message, toastStyles),
  error: (message: string) => toast.error(message, toastStyles),
  default: (message: string) => toast(message, toastStyles),
};

export default toastClient;
